const steps = [
  {
    number: "01",
    title: "Start with Warm White Walls",
    desc: "Paint walls in a warm white — not a cool or stark white. Look for tones with yellow or pink undertones. This is the foundation everything else rests on.",
  },
  {
    number: "02",
    title: "Choose Linen Bedding in Oat or Ivory",
    desc: "Washed linen bedding is the centrepiece of a calm bedroom. Choose oat, ivory, or warm white. Layer a flat sheet, duvet, and a folded throw at the foot.",
  },
  {
    number: "03",
    title: "Add a Natural Wood Bed Frame",
    desc: "A low-profile bed frame in natural oak or walnut grounds the room. Keep the headboard simple — a slatted or upholstered panel in linen works beautifully.",
  },
  {
    number: "04",
    title: "Layer Soft Textiles",
    desc: "Add a wool or cotton rug under the bed, linen curtains at the windows, and a knitted throw on a chair or bench. Texture is what makes a neutral room feel rich.",
  },
  {
    number: "05",
    title: "Edit Ruthlessly",
    desc: "Remove anything that doesn't need to be there. A calm bedroom has clear surfaces, hidden storage, and only a few carefully chosen objects. Less is genuinely more.",
  },
];

export default function CBNFormula() {
  return (
    <section className="py-24 bg-[#2C2825]">
      <div className="max-w-screen-xl mx-auto px-8 md:px-16">
        <div className="text-center mb-16">
          <p className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-4" style={{ fontFamily: "'Inter', sans-serif" }}>
            The Method
          </p>
          <h2 className="text-white text-3xl md:text-4xl mb-4" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
            The Calm Bedroom Formula
          </h2>
          <p className="text-white/50 text-sm leading-relaxed max-w-xl mx-auto" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
            Five steps to transform any bedroom into a genuinely restful neutral space.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className="relative bg-white/5 rounded-2xl p-7 border border-white/10"
            >
              <span
                className="block text-[#C4B5A5]/40 text-4xl mb-5 leading-none"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                {step.number}
              </span>
              <h3 className="text-white text-base mb-3" style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}>
                {step.title}
              </h3>
              <p className="text-white/50 text-xs leading-relaxed" style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}>
                {step.desc}
              </p>
              {i < steps.length - 1 && (
                <div className="hidden md:block absolute top-1/2 -right-3 w-6 h-6 flex items-center justify-center z-10">
                  <i className="ri-arrow-right-line text-[#C4B5A5]/30 text-sm" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
